import { Fancybox as Fancy } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

/**
 * Клас для ініціалізації Fancybox
 *
 * @package AGDS
 * @category Modules
 * @module Fancybox
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class Fancybox {
    /**
     * Конструктор
     *
     * @param {Object} options
     */
    constructor(options = {}) {}

    /**
     * Ініціалізація
     *
     * @returns {void}
     */
    init() {
        if (!Fancy) {
            console.warn("Fancybox not found");
            return;
        }

        const params = {
            ...Fancy.defaults,
            autoFocus: false,
            closeButton: false,
            dragToClose: true,
            placeFocusBack: true,
            compact: false,
            modal: true,
        };

        Fancy.bind("[data-fancybox]", params);
    }
}
